module.exports = __webpack_public_path__ + "img/como-ganhar.0f325232.jpg";